import Skeleton from "./Skeleton";

const StoreSkeleton = () => {
    return (
        <div style={{ width: "100%", backgroundColor: "rgb(28,28,28)", height: "92px", borderRadius: "16px", position: "relative" }}>
            <Skeleton width={"60px"} height={"60px"} type={"product"} style={{ position: "absolute", top: "14px", left: "16px" }} />
            <Skeleton width={"134px"} height={"13px"} type={"product"} style={{ position: "absolute", top: "16px", left: "90px" }} />
            <Skeleton width={"200px"} height={"13px"} type={"product"} style={{ position: "absolute", top: "36px", left: "90px" }} />
            <Skeleton width={"146px"} height={"10px"} type={"product"} style={{ position: "absolute", top: "57px", left: "90px" }} />
            <Skeleton width={"20px"} height={"20px"} type={"product"} style={{ position: "absolute", top: "32px", right: "20px" }} />
        </div>
    );
};

export default StoreSkeleton;
